;(function() {
/* @ngInject */
function CopyButtonController($window, Toast) {
  let vm = this;

  vm.copy = copy;

  function copy() {
    if ($window.navigator.clipboard && $window.navigator.clipboard.writeText) {
      $window.navigator.clipboard.writeText(String(vm.value))
        .then(() => Toast.showSuccess("Skopírované do schránky."))
        .catch(showCopyError);
      return;
    }

    showCopyError();
  }

  function showCopyError() {
    Toast.showError("Text sa nepodarilo skopírovať.");
  }
}

angular.module("firmaren")
  .component("copyButton", {
    templateUrl: "/app/shared/copy-button/copy-button.html",
    controller: CopyButtonController,
    controllerAs: "vm",
    bindings: {
      value: "<",
      label: "@",
      ariaLabel: "@"
    }
  });
}());
